
// Front
import Layout from './layout/reducer';

// Authentication Module
import Forget from './auth/forgetpwd/reducer';
import { rootReducer } from 'saga-slice';
import userSlice from './auth/login/userSlice';
import dataSlice from '../modules/dataSlice';
import coeffAbattEvSlice from '../modules/parametrage/CeofficiantAbattement/coeffAbattSlice';
import coeffAbattKmSlice from '../modules/parametrage/CoefficiantRelatif/coeffAbattKmSlice';
import parametrageSlice from '../modules/parametrage/ValeurVinal/parametrageSlice';
import clientSlice from '../modules/database/clientSlice';
import vehiculeSlice from '../modules/database/vehiculeSlice';
import vvinaleSlice from '../modules/valeurVinal/vvinaleSlice';


const modules = [userSlice,dataSlice,parametrageSlice, coeffAbattEvSlice,coeffAbattKmSlice, clientSlice, vehiculeSlice, vvinaleSlice];

const appReducer = rootReducer(modules, {
    // public
    Layout,
    Forget,
});


export default appReducer;